import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid2 as Grid,
    MenuItem,
    Stack,
    TextField,
} from "@mui/material"
import { NumberField } from "../../components/Fields/NumberField"
import { Label, LabelAndText } from "../../components/Typography/Typography"
import {
    DataReceivedStatus,
    ReceiptDetail,
    ReceiptShippingInfoWrapper,
    dataReceivedStatusUserDisplayValue,
} from "../../models/DataReceipt"
import { keysForStringEnum } from "../../utils/EnumUtils"
import { useDataReceiptStore } from "../../zstore/DataReceiptStore"

const dialogWidth = 440

export const ReceiptDetailDialog = () => {
    const dialogShippingInfoWrapper = useDataReceiptStore((state) => state.dialogShippingInfoWrapper)
    const setDialogShippingInfoWrapper = useDataReceiptStore((state) => state.setDialogShippingInfoWrapper)
    const selectedShippingInfoWrappers = useDataReceiptStore((state) => state.selectedShippingInfoWrappers)
    const setSelectedShippingInfoWrappers = useDataReceiptStore((state) => state.setSelectedShippingInfoWrappers)

    if (!dialogShippingInfoWrapper) {
        // Selected Mission Info is not available
        return null
    }

    const shippingDetail = dialogShippingInfoWrapper.detail

    const handleUpdateShippingInfoDetail = (detail: Partial<ReceiptDetail>) => {
        const wrapper: ReceiptShippingInfoWrapper = {
            ...dialogShippingInfoWrapper,
            detail: { ...dialogShippingInfoWrapper.detail, ...detail },
        }
        setDialogShippingInfoWrapper(wrapper)
    }

    const handleClose = () => setDialogShippingInfoWrapper(undefined)

    const handleSave = () => {
        const index = selectedShippingInfoWrappers.findIndex(
            (wrapper) => wrapper.shipping_info.id === dialogShippingInfoWrapper.shipping_info.id,
        )

        const newState = selectedShippingInfoWrappers.slice()
        newState.splice(index, 1, dialogShippingInfoWrapper)

        setSelectedShippingInfoWrappers(newState)
        handleClose()
    }

    return (
        <Dialog open={!!dialogShippingInfoWrapper} onClose={handleClose}>
            <DialogTitle>{dialogShippingInfoWrapper.mission.mission_name}</DialogTitle>
            <DialogContent sx={{ width: dialogWidth }}>
                <Stack gap={2} sx={{ mt: 2 }}>
                    <Grid container spacing={2}>
                        <Grid size={6}>
                            <TextField
                                select={true}
                                label="Status"
                                fullWidth={true}
                                required={true}
                                helperText={"Required"}
                                value={shippingDetail.status}
                                onChange={(event) =>
                                    handleUpdateShippingInfoDetail({ status: event.target.value as DataReceivedStatus })
                                }
                            >
                                {keysForStringEnum(DataReceivedStatus).map((option) => (
                                    <MenuItem key={option} value={option}>
                                        {dataReceivedStatusUserDisplayValue(option)}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid size={6}>
                            <NumberField
                                value={
                                    shippingDetail.size_in_gb ??
                                    dialogShippingInfoWrapper.shipping_info.raw_storage_size_gb
                                }
                                onChange={(value) => value && handleUpdateShippingInfoDetail({ size_in_gb: value })}
                                label={"Size (GB)"}
                                required={true}
                                fullWidth={true}
                                size="medium"
                            />
                        </Grid>
                    </Grid>
                    <TextField
                        value={shippingDetail.notes ?? ""}
                        label={"Data Receipt Notes"}
                        onChange={(event) => handleUpdateShippingInfoDetail({ notes: event.target.value })}
                        fullWidth={true}
                        multiline={true}
                    />
                    <Divider />
                    <Label disableGutter={true}>Notes from Mission</Label>
                    <LabelAndText label="Error Notes">
                        {dialogShippingInfoWrapper.mission.error_notes?.trim() || "None"}
                    </LabelAndText>
                    <LabelAndText label="Actions Taken">
                        {dialogShippingInfoWrapper.mission.error_action?.trim() || "None"}
                    </LabelAndText>
                    <LabelAndText label="Sensor Notes">
                        {dialogShippingInfoWrapper.mission.sensor_notes?.trim() || "None"}
                    </LabelAndText>
                </Stack>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleSave} variant="contained">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    )
}
